import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule,ColumnChooserService, PageService, SortService, FilterService, ResizeService  } from '@syncfusion/ej2-angular-grids';
import { CareCoordinatorComponent } from './care-coordinator.component';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { CareCoordinatorRoutingModule } from './care-coordinator-routing.module';
@NgModule({
  declarations: [
    CareCoordinatorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    GridModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    CareCoordinatorRoutingModule
  ],
  exports:[CareCoordinatorComponent],
  providers: [ColumnChooserService,PageService,SortService,FilterService,ResizeService ],
})
export class CareCoordinatorModule { }
